import { render } from "./TaskOSDisplay.vue?vue&type=template&id=76d0a03a&scoped=true"
import script from "./TaskOSDisplay.vue?vue&type=script&lang=js"
export * from "./TaskOSDisplay.vue?vue&type=script&lang=js"

import "./TaskOSDisplay.vue?vue&type=style&index=0&id=76d0a03a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d0a03a"]])

export default __exports__